import React from "react";

// Statuslevenscyclus inkooporder: concept → verstuurd → bevestigd → (ingeboekt)
export const INKOOP_STATUS = {
  concept: { label: "Concept", cls: "bg-secondary text-secondary-foreground border-transparent" },
  verstuurd: { label: "Verstuurd", cls: "bg-blue-100 text-blue-700 border-blue-200" },
  bevestigd: { label: "Bevestigd", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  deels_ingeboekt: { label: "Deels ingeboekt", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  ingeboekt: { label: "Ingeboekt", cls: "bg-emerald-600 text-white border-transparent" },
};

export function inkoopStatusLabel(status) {
  return INKOOP_STATUS[status]?.label || (status || "Concept");
}

export function InkoopStatusBadge({ status, className = "" }) {
  const s = INKOOP_STATUS[status] || INKOOP_STATUS.concept;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls} ${className}`}
      data-testid="inkoop-status-badge"
    >
      {s.label}
    </span>
  );
}
